<template>
  <v-container>
    <sub-navigation></sub-navigation>
    <v-layout row wrap>
      <v-flex xs12>
        <!-- <h1 class="h2 mb-30">Moje faktury</h1> -->
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0 mt-3"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
          :loading="loadingTable"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>{{ props.item.variabilni_symbol }}</td>
            <td>{{ props.item.castka | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td class="text-xs-right">
              <v-btn color="orange" dark depressed class="ma-0" @click="downloadPDF(props.item.id)" v-if="props.item.fa_pdf"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout</v-btn>
              <!-- <a :href="api_url + 'faktury/' + props.item.id + '/pdf'" v-if="props.item.fa_pdf" target="_blank">
                <v-btn color="orange" dark class="elevation-0 ma-0 bold"><v-icon class="mr-3">save_alt</v-icon> Stáhnout</v-btn>
              </a> -->
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        headers: [
          { text: 'Datum', value: 'datum' },
          { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
          { text: 'Částka', value: 'castka', sortable: false },
          { text: 'Faktura', value: null, sortable: false, align: "right" }
        ],
        items: [],
        timeout: null,
        counter: 0,
        loadingTable: false,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        }
      }
    },
    computed: {
      api_url () {
        return window.api.$api_url;
      }
    },
    watch: {
      pagination: {
        handler: function(newValue) {
          if (!this.loadingTable)
             this.load();
        },
        deep: true
      },
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("faktury/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      downloadPDF (id) {
        var url = 'faktury/' + id + '/pdf';
        window.api.download(url);
      }
    }
  }
</script>
